import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";
import Strf from "shared/components/Strf";

import "./ActivateReadReceipt.scss";

const ActivateReadReceipt = ({
	tokenCount,
	onActivateReadReceiptClose,
	onActivateReadReceipt,
}) => {
	return (
		<div className="activate-read-receipt">
			<div className="activate-read-receipt-text">
				<Str className="activate-read-receipt-header">
					Would you like to activate?
				</Str>
				<Strf vars={{ tokenCount }}>You have $tokenCount left</Strf>
			</div>
			<div className="activate-read-receipt-btns">
				<button
					className="activate-read-receipt-btn"
					onClick={onActivateReadReceiptClose}
				>
					<Str>Cancel</Str>
				</button>
				<button
					className="activate-read-receipt-btn"
					onClick={(evt) => {
						evt.preventDefault();
						onActivateReadReceipt();
					}}
				>
					<Str>OK</Str>
				</button>
			</div>
		</div>
	);
};

ActivateReadReceipt.propTypes = {
	tokenCount: PropTypes.number.isRequired,
	onActivateReadReceiptClose: PropTypes.func.isRequired,
	onActivateReadReceipt: PropTypes.func.isRequired,
};

export default ActivateReadReceipt;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/ReadReceiptCTA/ActivateReadReceipt/ActivateReadReceipt.jsx